import { useState } from "react";


export const Calculation = () => {

    const [pace, setPace] = useState("");
    const [kms, setKms] = useState("");
    const [caloriesVal, setCaloriesVal] = useState("");


    const handleReset = (e) => {

        e.preventDefault();
        const form = document.querySelector('form');
        form.reset();
        setPace("");
        setKms("");
        setCaloriesVal("");
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    
        // Get input values
        const distance_travelled = parseFloat(e.target.distance_travelled.value); // Distance in miles or kilometers
        const hours = parseInt(e.target.hours.value) || 0;
        const minutes = parseInt(e.target.minutes.value) || 0;
        const seconds = parseInt(e.target.seconds.value) || 0;
        const weight = parseInt(e.target.weight.value); // Weight in kilograms
    
        // Convert total time to seconds
        const totalTimeInSeconds = (hours * 3600) + (minutes * 60) + seconds;
    
        // Calculate average pace in seconds per unit distance
        const averagePaceInSeconds = totalTimeInSeconds / distance_travelled;
    
        // Convert average pace to minutes and seconds
        const averagePaceMinutes = Math.floor(averagePaceInSeconds / 60);
        const averagePaceSeconds = Math.round(averagePaceInSeconds % 60);
    
        // Calculate the average speed in miles per hour
        // MET value for running (adjust based on speed/intensity)
        // cal met value for running is 9.7
        const speedDividedByPace = 60 / (averagePaceMinutes + averagePaceSeconds / 60);
        console.log(speedDividedByPace)
        const metValue = speedDividedByPace* 1.8 ; // Example: 6 mph (9.7 km/h)

        // Calculate calories burned
        const totalTimeInHours = (hours * 3600 + minutes * 60 + seconds) / 3600;
        const caloriesBurned = metValue * weight * totalTimeInHours;

        // Log the calories burned
       setCaloriesVal(`Calories Burned: ${caloriesBurned.toFixed(2)} kcal`);

       const kmsHours = (averagePaceMinutes / 1.60934).toFixed(0);
    const kmsMinutes = (averagePaceMinutes % 1.60934).toFixed(0);
      
        // Log the average pace
        setPace(`Average Pace: ${averagePaceMinutes}:${averagePaceSeconds.toString().padStart(2, '0')} minutes per mile`);
        setKms(`Average Pace: ${kmsHours}:${kmsMinutes.toString().padStart(2, '0')} minutes per kilometer`);
    };

  return (
    <>
    <h1 className="text-center text-4xl mb-6">Running Pace</h1>    
<form onSubmit={handleSubmit}>
    <div className="grid gap-6 mb-6 md:grid-cols-2">

    
    <div className="flex justify-start items-center">
        <div className="mx-4">
            <label htmlFor="distance_travelled" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Distance in Miles</label>
            <input type="text" id="distance_travelled" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Distance Travelled" required />
        </div>

        <div className="mx-4">
            <label htmlFor="weight" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Weight kgs</label>
            <input type="number" id="weight" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Weight"  />
        </div>

    </div>

        <div className="flex justify-start items-center">

            <div>
                <label htmlFor="hours" className="block  mb-2 text-sm font-medium text-gray-900 dark:text-white">Hour(s)</label>
                <input type="number" id="hours" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="0"  />
            </div>

            <div className="mx-4">
                <label htmlFor="minutes" className="block  mb-2 text-sm font-medium text-gray-900 dark:text-white">Minutes(s)</label>
                <input type="number" id="minutes" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="0"  />
            </div>

            <div>
                <label htmlFor="seconds" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Seconds(s)</label>
                <input type="number" id="seconds" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500  focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="0"  />
            </div>

            

        </div>

        <h2 className="text-center m-4 text-lg">{pace}</h2>
        <h2 className="text-center m-4 text-lg">{kms}</h2>
        <h2 className="text-center m-4 text-lg">{caloriesVal}</h2>

    </div>
    <button type="submit" className="m-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>


    <button onClick={handleReset} className=" m-4 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Clear</button>
</form>

    </>
  )
}
